<template>
  <div>
    <el-row :gutter="10" type="flex" justify="start" align="middle" style="margin-bottom: 20px;">
      <el-col :span="2">
        <el-select v-model="selectData.selectedYear" placeholder="年份">
          <el-option v-for="year in years" :key="year" :label="year" :value="year"></el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <el-select v-model="selectData.selectedMonth" placeholder="月份">
          <el-option v-for="month in months" :key="month" :label="month" :value="month"></el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <el-select v-model="selectData.type" placeholder="类型">
          <el-option v-for="type in types" :key="type.value" :label="type.label" :value="type.value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <el-select v-model="selectData.station" placeholder="工站">
          <el-option v-for="station in stations" :key="station.value" :label="station.label" :value="station.value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" :loading="loading" @click="updateDaysInMonth">搜索</el-button>
      </el-col>
    </el-row>
    <div class="table-container">
      <el-table :data="items" border style="width: 100%;height: 650px" :show-summary="true" :summary-method="getSummary">
        <el-table-column fixed  prop="name" label="色" width="100"></el-table-column>
        <el-table-column v-for="day in daysInMonth" :key="day" :label="getFormattedDate(day)" width="100" show-overflow-tooltip>
          <template v-slot="scope">
            {{ scope.row.data[day - 1] }}
          </template>
        </el-table-column>
        <el-table-column label="合计" width="100" fixed="right">
          <template v-slot="scope">
            {{ scope.row.total }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MfgPaintingProductionStatistics2",
  data() {
    return {
      loading:false,
      selectData:{
        selectedYear: new Date().getFullYear(),
        selectedMonth: new Date().getMonth() + 1,
        type:'xc',
        station:'qcl',
        unit:'case'
      },
      years: [],
      months: [],
      types:[
        {label:"型材",value:"xc"},
        {label:"部材",value:"bc"},
        {label:"部品",value:"bp"},
      ],
      stations:[
        {label:"前处理",value:"qcl"},
        {label:"喷涂",value:"pt"},
      ],
      daysInMonth: [],
      items: []
    };
  },
  created() {
    this.initializeYearsAndMonths();
    this.updateDaysInMonth();
  },
  methods: {
    initializeYearsAndMonths() {
      const currentYear = new Date().getFullYear();
      this.years = Array.from({ length: 10 }, (_, i) => currentYear - 5 + i);
      this.months = Array.from({ length: 12 }, (_, i) => i + 1);
    },
    async updateDaysInMonth() {
      this.loading=true;
      this.daysInMonth = this.getDaysInMonth(this.selectData.selectedYear, this.selectData.selectedMonth);
      let {data: res} = await this.$axios.post('mfg/tz/getPaintingProductionStatistics', this.selectData);
      if (res.code !== 0) {
        this.$message.error(res.message)
        return [];
      }
      this.items = res.data;
      this.loading=false;
    },
    getDaysInMonth(year, month) {
      return new Array(new Date(year, month, 0).getDate()).fill().map((_, i) => i + 1);
    },
    getFormattedDate(day) {
      return `${this.selectData.selectedMonth}/${day}`;
    },
    getColumnTotal(day) {
      return this.items.reduce((sum, item) => sum + item.data[day - 1], 0);
    },
    getTotalTotal() {
      const total = this.items.reduce((sum, item) => sum + item.total, 0);
      return parseFloat(total.toFixed(2)); // 保留两位小数并转换为数字
    },
    getSummary(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => item.data[index - 1]);
        const sum = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
        sums[index] = parseFloat(sum.toFixed(2)); // 保留两位小数并转换为数字
      });

      // Add total of total column
      sums[sums.length - 1] = this.getTotalTotal();

      return sums;
    }
  }
}
</script>

<style scoped>

/*.div{*/
/*  width: 98%;*/
/*}*/

.table-container {
  position: relative;
}

.el-table__footer-wrapper {
  position: sticky;
  bottom: 0;
  background-color: white;
  z-index: 1;
}

/*.summary-row span {*/
/*  flex: 1;*/
/*  text-align: center;*/
/*}*/

.table-container ::v-deep(.el-scrollbar__wrap){
  padding-bottom: 0px !important;
}

</style>